import React, {useCallback, useState, useMemo, useEffect} from "react"
import { graphql } from "gatsby"
import {ReportForm} from "../components/reportForm/reportForm";
import Layout from "../components/layout/layout";
const {Helmet} = require("react-helmet");

const styles = require("../styles/report-page.module.scss");


export default ( {data} ) => {
    const report = useMemo(() => data.allStrapiReportPage.edges[0].node, [data.allStrapiReportPage.edges, data.allStrapiReportPage.edges[0].node]);
    const [thanks, setThanks] = useState(false);
    const showDownload = useCallback(() => setThanks(true),[]);

    useEffect(() => {
        if (typeof window !== "undefined") {
            let url = new URL(window.location.href);
            let searchParams = new URLSearchParams(url.search);
            if (searchParams.get('utm_source') !== null) {
                localStorage.setItem('final_source', searchParams.get('utm_source'));
                if (localStorage.getItem('first_source') === null) {
                    localStorage.setItem('first_source', searchParams.get('utm_source'));
                }
            }
        }
    }, [typeof window])

    return (
        <Layout>
            <Helmet>
                <title>{report.title}</title>
                <meta name="description" content={report.description} />
                {report.featured_image && report.featured_image.publicURL &&
                <meta name="image" content={report.featured_image.publicURL} /> &&
                <meta property="og:image" content={report.featured_image.publicURL} />}
            </Helmet>
            <div className={styles.landingPageDownloadPDF}>
                <div className={`${styles.container} ${styles.sideBySide}`}>
                    {!thanks &&
                    <div className={`${styles.oneSide} ${styles.text}`}>
                        <div className={styles.textCont}>
                            <div className={`${styles.oneLine} ${styles.landingLogo}`}>
                                <a className={styles.logoCont} href="/" title="" target="_blank" rel="noopener noreferrer">
                                    <img src="/images/new/logo/logo_dark_colorful.png" alt=""/>
                                </a>
                            </div>
                            <div className={`${styles.oneLine} ${styles.titleCont}`}>
                                <h1 className={styles.title}>{report.title}</h1>
                            </div>
                            <div className={`${styles.oneLine} ${styles.textCont}`}>
                                    <div className={styles.onePar}>
                                        {report.description}
                                    </div>
                            </div>
                        </div>
                    </div>
                    }
                    <div className={`${styles.oneSide} ${styles.form}`}>
                        {!thanks ?
                            <div className={styles.formCont}>
                                <div className={styles.title}>
                                    Download Your Free Report
                                </div>
                                <ReportForm onSubmit={showDownload} reportReason={report.title}/>
                            </div>
                            :
                            <>
                                <div className={`${styles.oneLine}  ${styles.landingLogo}  ${styles.thankYouForm}`}>
                                    <a className={styles.logoCont2} href="/" title="" target="_blank" rel="noopener noreferrer">
                                        <img src="/images/new/logo/logo_dark_colorful.png" className={styles.darkLogo} alt=""/>
                                    </a>
                                </div>
                                <div className={`${styles.formCont}  ${styles.thankYouForm}`}>
                                    <img className={styles.thanksImage} src="/images/new/present.png" alt=""/>
                                    <div className={styles.title}>
                                        Thanks! You can Download the PDF now
                                    </div>
                                    <input type="hidden" name="whatToDo" value="send"/>
                                    <a href={report.file.publicURL} title="" download={`${report.fileName}.pdf`} target="_blank" rel="noopener noreferrer">
                                        <button className={`${styles.gradButt}  ${styles.gradButtLarge}  ${styles.gradButtBlue} ${styles.landingPageCtaButt}`}>
                                            <i className="fas fa-file-pdf"/>Download
                                        </button>
                                    </a>
                                </div>
                            </>
                        }
                    </div>
            </div>
            </div>
        </Layout>
    )
}
export const query = graphql`
  query($slug: String!) {
  allStrapiReportPage(filter: { slug: { eq: $slug } }) {
        edges {
          node {
            title
            slug
            description
            fileName
            file {
              publicURL
            }
            featured_image {
              publicURL
            }
          }
        }
      }
  }
`